export default {_name:'attachment.pane',module:'Attachment/Upload',view:'Element/Attachment/Pane',options:{key:'attachment',size:[150,150]}}